<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B4J5vv/tc-custom/9780374716134.jpg?1719987223236" alt="This image is the cover for the book Neighborhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neighborhood
      </h1>
      <p class="bookDescription body article font2">
        <p><b>WINNER OF THE NOBEL PRIZE IN LITERATURE</b><br/><b><br/>A thrilling tale of desire and Peruvian corruption swirls around a scandalous exposé that leads to murder</b><br/><br/>From the Nobel Laureate comes a politically charged detective novel weaving through the underbelly of Peruvian privilege. In the 1990s, during the turbulent and deeply corrupt years of Alberto Fujimori’s presidency, two wealthy couples of Lima’s high society become embroiled in a disturbing vortex of erotic adventures and politically driven blackmail. <br/><br/>One day Enrique, a high-profile businessman, receives a visit from Rolando Garro, the editor of a notorious magazine that specializes in salacious exposés. Garro presents Enrique with lewd pictures from an old business trip and demands that he invest in the magazine. Enrique refuses, and the next day the pictures are on the front page. Meanwhile, Enrique’s wife is in the midst of a passionate and secret affair with the wife of Enrique’s lawyer and best friend. When Garro shows up murdered, the two couples are thrown into a whirlwind of navigating Peru’s unspoken laws and customs, while the staff of the magazine embark on their greatest exposé yet.<br/><br/>Ironic and sensual, provocative and redemptive, the novel swirls into the kind of restless realism that has become Mario Vargas Llosa’s signature style. A twisting, unpredictable tale, <i>The Neighborhood</i> is at once a scathing indictment of Fujimori’s regime and a crime thriller that evokes the vulgarity of freedom in a corrupt system.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mario Vargas Llosa, Edith Grossman
      </h2>
      
      <p class="authorDescription body article"><P><B>Mario Vargas Llosa </B>was awarded the Nobel Prize in Literature in 2010 “for his cartography of structures of power and his trenchant images of the individual’s resistance, revolt, and defeat.” He has also won the Cervantes Prize, the Spanish-speaking world’s most distinguished literary honor. His many works include <I>The Discreet Hero</I>, <I>The Feast of the Goat</I>, <I>The Bad Girl</I>, and <I>Aunt Julia and the Scriptwriter</I>, all published by FSG.<br><br><B>Edith Grossman</B> has translated the works of the Nobel laureates Mario Vargas Llosa and Gabriel García Márquez, among others. Her version of Miguel de Cervantes’s <I>Don Quixote </I>is considered the finest translation of the Spanish masterpiece in the English language.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d1cb78d